/**
 * Base class for every domain error in the monorepo. Never throw a bare `Error`
 * — extend `AppError` so callers can branch on a stable `code` and map to an
 * HTTP status at the edge. Each app's `src/errors/` dir owns its subclasses.
 */
export abstract class AppError extends Error {
  /** Stable, machine-readable identifier (e.g. `invalid_id`). */
  abstract readonly code: string;
  /** Suggested HTTP status when this bubbles to the edge. */
  readonly statusCode: number;

  constructor(message: string, options?: { cause?: unknown; statusCode?: number }) {
    super(message, options?.cause !== undefined ? { cause: options.cause } : undefined);
    this.name = new.target.name;
    this.statusCode = options?.statusCode ?? 500;
  }
}
